/**
 * Compensafe Date Range Selector v1.1
 *
 * Depends On:
 *  JQuery 1.7.2
 *  JQueryUI 1.8.19
 *
 *  Options:
 *      dateRange: date range to initialize to.
 *          uses same syntax as setDateRange().
 *          Default is a function that returns 'prev' if today is the 1st of the month
 *          otherwise it returns 'mtd'.
 *
 *      dateRanges: predefined date ranges to display
 *          or, null indicates to display all date ranges.
 *          Default is null.
 *
 *          Custom date ranges can also be declared as static values or functions:
 *            { label: 'Test', value: 'test', dateRange: function (today) { return { from: new Date("01/01/2013"), to: new Date("01/01/2014") }; } },
 *            { label: 'Test2', value: 'test2', dateRange: { from: new Date("01/03/2013"), to: new Date("01/03/2014") }
 *
 *      noPredefinedDateRanges: if true, the don't display the predefined date range buttons.
 *          Default is false.
 *
 *      directInput: if false, then user cannot enter dates using the date fields and the date fields
 *          only display the selected date range. The user can still set the date range using the
 *          predefined date range buttons.
 *          Default is true.
 *
 *      datePickerNumberOfMonths: this value indicates how many months the date picker calendars shold
 *          display.
 *          Default is 1.
 *
 *  Public API:
 *      setToDate(To): set the TO date field
 *
 *      setFromDate(From): set the FROM date field
 *
 *      setDateRange(): set the date range, FROM and TO.
 *          string value of one of the predefined date ranges
 *          or, array of date values [ from, to ]
 *          or, an object with properties 'from' and 'to'
 *          or, a function that returns one of the other possibly types
 *
 *      getDateRange(): returns an object with properties 'from' and 'to'
 *
 *      getPredefinedRange(): returns the selected predefined range
 *
 *      calcDateRange(range): a util function for computing predefined date ranges
 *
 */
(function($){
    $.widget("compensafe.dateRange",
    {
        options:
        {
            label: null,
            disableChangeEvent: false,
            defaultDateRanges:
            [
                { label: 'Prev', value: 'prev' },
                { label: 'MTD', value: 'mtd' },
                { label: 'QTD', value: 'qtd' },
                { label: '1m', value: '1m' },
                { label: '3m', value: '3m' },
                { label: '6m', value: '6m' },
                { label: 'YTD', value: 'ytd' },
                { label: '1y', value: '1y' }
            ],
            dateRange: function () { 
                var rc = null; 
                if (new Date().getDate() < 2) {
                    rc = 'prev';
                }
                else {
                    rc = 'mtd';
                }
                return rc; 
            },
            noPredefinedDateRanges: false,
            payrollDateRange: false,
            // allow user to pick specific dates, false: user must use predefined buttons
            directInput: true,
            datePickerNumberOfMonths: 1,
            hideCustomDateInput: false,
            payCalendars: [],
            payCalendarID: 0,
            payPeriodOffset: 0,
        },
        _create: function()
        {
            var self = this;
            self._createPrefix();

            var localDateRange = JSON.parse(localStorage.getItem('DateRange'));
            var localPayrollDateRange = JSON.parse(localStorage.getItem('PayrollDateRange'));
            var localPayPeriodOffset = JSON.parse(localStorage.getItem('PayPeriodOffset'));

            //This is a duplication of logic in Reporting/Default.aspx. I added it here as well in case the widget is used outside of a report.
            if (!self.options.payrollDateRange && !self.isDateRangeObjectValid(self.options.dateRange)) {
                var rc = null;
                if (new Date().getDate() < 2) {
                    rc = 'prev';
                }
                else {
                    rc = 'mtd';
                }
                self.options.dateRange = rc;
            }

            self.element.addClass('ui-widget');
            self.element.addClass('compensafe-dateRange');

            if (self.options.label != null) {
                var $label = $('<label></label>').attr('for', self._id('from')).text(self.options.label);
                self.element.append($label);
            }

            var $payCalendarDdl = $('<select/>');
            $payCalendarDdl.attr('id', self._id('payCalendars'));
            $payCalendarDdl.css('max-width', '200px');
            $payCalendarDdl.css('margin-right', '4px');

            self.element.append($payCalendarDdl);

            self.setPayCalendar(self.options.payCalendars, false);

            $('#' + self._id('payCalendars')).on('change', function () {
                var newPayCalendarID = parseInt($(this).val(), 10);
                self.options.payCalendarID = newPayCalendarID;
                localStorage.setItem('payCalendarID', JSON.stringify(newPayCalendarID));

                self.setDateRange('thisPayroll');
                self._triggerChange();
                self.setPayCalendarIDInSession(newPayCalendarID);
            });

            var htmlTemplate =
                '<div id="' + self._id('predefinedDateRanges') + '" class="compensafe-dateRange-predefinedDateRanges"></div>' +
                '<div class="compensafe-dateRange-controlGroup">';

            if (self.options.hideCustomDateInput === false) {
                htmlTemplate = htmlTemplate + '<input type="text" id="' + self._id('from') + '" name="' + self._id('from') + '" class="compensafe-dateRange-date"/>' +
                    '<label for="' + self._id('to') + '">-</label>' +
                    '<input type="text" id="' + self._id('to') + '" name="' + self._id('to') + '" class="compensafe-dateRange-date"/>';
            }
            else {
                htmlTemplate = htmlTemplate + '<input type="hidden" id="' + self._id('from') + '" name="' + self._id('from') + '" class="compensafe-dateRange-date"/>' +
                    '<input type="hidden" id="' + self._id('to') + '" name="' + self._id('to') + '" class="compensafe-dateRange-date"/>';
            }

            htmlTemplate = htmlTemplate + '</div>';

            var $dr = $(htmlTemplate);
            self.element.append($dr);

            // if dateRanges is set, it overrides defaultDateRanges
            if(!self.options.dateRanges)
            {
                self.options.dateRanges = self.options.defaultDateRanges;
            }

            var $pdr = $('#' + self._id('predefinedDateRanges'));

            if(self.options.noPredefinedDateRanges === true)
            {
                $pdr.addClass('ui-helper-hidden');
            }
            else if (self.options.payrollDateRange) {

                if (localPayrollDateRange) {
                    self.options.payrollDateRange = localPayrollDateRange;
                }

                if(typeof localPayPeriodOffset == "number") {
                    self.options.payPeriodOffset = localPayPeriodOffset;
                }

                $('<input/>').attr('type', 'radio')
                    .attr('id', self._id('pastPayroll'))
                    .attr('name', self._id('dateRange'))
                    .val('pastPayroll')
                    .appendTo($pdr);

                $('<label></label>').attr('for', self._id('pastPayroll'))
                    .text('Past Pay')
                    .prepend('<span class="fa fa-lg fa-caret-left" style="padding-right: 5px;"></span>')
                    .appendTo($pdr);

                $('<input/>').attr('type', 'radio')
                    .attr('id', self._id('thisPayroll'))
                    .attr('name', self._id('dateRange'))
                    .val('thisPayroll')
                    .appendTo($pdr);
                $('<label></label>').attr('for', self._id('thisPayroll'))
                    .text('This Pay')
                    .appendTo($pdr);

                $('<input/>').attr('type', 'radio')
                    .attr('id', self._id('futurePayroll'))
                    .attr('name', self._id('dateRange'))
                    .val('futurePayroll')
                    .appendTo($pdr);
                $('<label></label>').attr('for', self._id('futurePayroll'))
                    .text('Future Pay')
                    .append('<span class="fa fa-lg fa-caret-right" style="padding-left: 5px;"></span>')
                    .appendTo($pdr);
                
                $pdr.find("input[type=radio]").checkboxradio({
                    icon: false
                });

                self.options.dateRanges = [{ label: 'This Pay', value: 'thisPayroll' }];

                if (self.options.payPeriodOffsetMode === "custom") {
                    self._disablePastFutureButtons(true);
                }
            }
            else
            {
                if (localDateRange) {
                    self.options.dateRange = localDateRange;
                }

                $.each(self.options.dateRanges, function(i, v)
                {
                    var x = null;

                    if(typeof(v) === "object")
                    {
                        x = v;
                    }
                    else if(typeof(v) === "string")
                    {
                        for(var i = 0; i < self.options.defaultDateRanges.length; i++)
                        {
                            if(self.options.defaultDateRanges[i].value === v)
                            {
                                x = self.options.defaultDateRanges[i];
                                break;
                            }
                        }

                        if(x === null)
                        {
                            x = { label: v, value: v };
                        }
                    }

                    $('<input/>').attr('type','radio')
                        .attr('id', self._id(x.value))
                        .attr('name', self._id('dateRange'))
                        .val(x.value)
                        .appendTo($pdr);
                    $('<label></label>').attr('for', self._id(x.value))
                        .text(x.label)
                        .appendTo($pdr);
                });
                $pdr.find("input[type=radio]").checkboxradio({
                    icon: false
                });
            }
            var $dts = $('#' + self._id('from') + ',#' + self._id('to'));
            $dts.datepicker({
                defaultDate: "+1w",
                changeMonth: true,
                numberOfMonths: self.options.datePickerNumberOfMonths,
                onSelect: function( selectedDate )
                {
                    self._triggerChange();
                    self._triggerDatePickerSelectChange();
                    self._disablePastFutureButtons(true);
                }
            });

            $dts.on('focusout', function() {
                self._triggerChange();
                self._disablePastFutureButtons(true);
            });

            if(self.options.directInput === false)
            {
                $dts.datepicker("disable").addClass("compensafe-dateRange-dateReadOnly");
            }

            $("input[name='" + self._id('dateRange') + "']").on('change', function () {
                //var v = $("input[name='" + self._id('dateRange') + "']:checked").val();
                var v = $(this).val();
                self.setDateRange(v);
            });

            var dateRange = self.options.payrollDateRange;
            if(dateRange && typeof dateRange === "boolean") {
                dateRange = "thisPayroll";
            }
            else if(dateRange == null || dateRange === undefined || dateRange == false) {
                dateRange = self.options.dateRange;
            }

            self.setDateRange(dateRange);
        },
        _createPrefix: function()
        {
            var self = this;
            // if element has an id, then use that for prefix
            var id = self.element.attr('id');
            if(id == null)
            {
                id = self.widgetBaseClass + parseInt(Math.random() * 10000);
            }

            self.options.prefix = id + '-';
        },
        _id: function(id)
        {
            var self = this;
            return self.options.prefix + id;
        },
        _selectPredefinedButton: function(rangeId)
        {
            var self = this;
            var $pdr = $('#' + self._id('predefinedDateRanges'));

            if (rangeId === null)
            {
                $pdr.find('input').prop('checked', false);
            }
            else if (rangeId === 'pastPayroll' || rangeId === 'futurePayroll') {
                if (self.options.payPeriodOffset === 0) {
                    $pdr.find('input').prop('checked', false);
                    $pdr.find("input[value='thisPayroll']").prop('checked', true);
                }
                else {
                    $pdr.find('input').prop('checked', false);
                }
            }
            else
            {
                //$pdr.find("input[value='" + rangeId + "']").attr('checked','checked');
                $pdr.find("input[value='" + rangeId + "']").prop('checked', true);
            }
            $pdr.find("input[type=radio]").checkboxradio({
                icon: false
            });
        },
        _triggerChange: function(dr, pc) {
            var self = this;

            if (self.options.disableChangeEvent === false) {
                var drx, pcx;
                if(typeof dr === "undefined") {
                    drx = self.getDateRange();
                }
                else {
                    drx = dr;
                }
                if (typeof pc === "undefined") {
                    pcx = self.getPayCalendar();
                }
                else {
                    pcx = pc;
                }

                var eventData = $.extend({}, drx, pcx || {});

                clearTimeout(self._timeout);
                self._timeout = window.setTimeout(function () {
                    self._trigger("change", null, eventData);
                }, 800);

                if (self.options.payrollDateRange) {
                    this.setPayrollStartStopDateInSession();
                }
                else {
                    this.setStartStopDateInSession();
                }

                this.setDateRangeLocalStorageValues();
                this.setPayCalendarLocalStorageValue();
            }
        },
        _triggerDatePickerSelectChange: function () {
            var self = this;
            self._selectPredefinedButton(null);
        },
        _disablePastFutureButtons: function (disable) {
            var self = this;
            $('#' + self._id('pastPayroll')).prop("disabled", disable);
            $('#' + self._id('futurePayroll')).prop("disabled", disable);

            if (disable) {
                self.options.payPeriodOffsetMode = "custom";
            }
            else {
                self.options.payPeriodOffsetMode = "paydate";
            }
        },
        _isSameDay: function (date1, date2) {
            if (date1 === null || date1 === undefined ||
                date2 === null || date2 === undefined)
                return false;

            if(typeof date1 === "string") {
                date1 = new Date(date1);
            }

            if(typeof date2 === "string") {
                date2 = new Date(date2);
            }

            var first = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
            var second = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

            return first.getTime() === second.getTime();
        },
        _setOption: function(key, value)
        {
            var self = this;
            if (key === "disableChangeEvent") {
                self.options.disableChangeEvent = value;
            }
        },
        destroy: function()
        {
            // In jQuery UI 1.8, you must invoke the destroy method from the base widget
            $.Widget.prototype.destroy.call( this );
            // In jQuery UI 1.9 and above, you would define _destroy instead of destroy and not call the base method

            this.element.empty();
        },
        _destroy: function () {
            this.element.empty();
        },
        isValidDate: function (date) {
            return Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date.getTime());
        },
        isDateRangeObjectValid: function (dateRange) {
            var self = this;
            return dateRange &&
                typeof dateRange === "object" &&
                self.isValidDate(dateRange.from) &&
                self.isValidDate(dateRange.to);
        },
        setToDate: function (To, noChangeTrigger)
        {
            var self = this;
            $('#' + self._id('to')).datepicker("setDate", To);

            if (noChangeTrigger !== true) {
                self._triggerChange();
            }
        },
        setFromDate: function (From, noChangeTrigger)
        {
            var self = this;
            $('#' + self._id('from')).datepicker("setDate", From);

            if (noChangeTrigger !== true) {
                self._triggerChange();
            }
        },
        setDateRange: function(range, noChangeTrigger)
        {
            var self = this;

            if(typeof(range) === "string")
            {
                var jqFrom = $('#' + self._id('from'));
                var jqTo = $('#' + self._id('to'));
                var dtRange = self.calcDateRange(range, true);
                jqFrom.datepicker('setDate', dtRange.from);
                jqTo.datepicker('setDate', dtRange.to);

                self._selectPredefinedButton(range);

                if (noChangeTrigger !== true) {
                    self._triggerChange(dtRange);
                }
            }
            else if(typeof(range) === "object")
            {
                var f;
                var t;
                if (Array.isArray(range))
                {
                    if(range.length > 0)
                    {
                        self.setFromDate(range[0], noChangeTrigger);
                        f = range[0];

                        if(range.length > 1)
                        {
                            self.setToDate(range[1], noChangeTrigger);
                            t = range[1];
                        }
                    }
                }
                else
                {
                    if(range.from)
                    {
                        self.setFromDate(range.from, noChangeTrigger);
                        f = range.from;
                    }

                    if(range.to)
                    {
                        self.setToDate(range.to, noChangeTrigger);
                        t = range.to;
                    }
                }

                var pb = null;
                for (var i = 0; i < self.options.dateRanges.length; i++)
                {
                    var btn = self.options.dateRanges[i];
                    var myRange = self.calcDateRange(btn.value, false);
                    if (self._isSameDay(myRange.from, f) && self._isSameDay(myRange.to, t))
                    {
                        pb = btn.value;
                        break;
                    }
                }

                self._selectPredefinedButton(pb);
            }
            else if(typeof(range) === 'function')
            {
                // call self recursively with result from function
                self.setDateRange(range(), noChangeTrigger);
            }
        },
        setPayCalendar: function (payCalendars, noChangeTrigger) {
            var self = this;
            var $payCalendarDdl = $('#' + self._id('payCalendars'));

            var localPayCalendar = JSON.parse(localStorage.getItem('payCalendarID'));
            if (localPayCalendar) {
                self.options.payCalendarID = localPayCalendar;
                self.setPayCalendarIDInSession(localPayCalendar);
            }

            if (typeof (payCalendars) === "object") {
                self.options.payCalendars = payCalendars;
                $payCalendarDdl.empty();

                $payCalendarDdl.append($('<option>', {
                    value: 0,
                    text: "All"
                }));

                $.each(self.options.payCalendars, function (i, item) {
                    $payCalendarDdl.append($('<option>', {
                        value: item.PayCalendarID,
                        text: item.CalendarName
                    }));
                });
            }

            if (self.options.payCalendars.length < 2) {
                $payCalendarDdl.css('display', 'none');
            }
            else {
                $payCalendarDdl.val(self.options.payCalendarID);
                $payCalendarDdl.css('display', '');
            }

            if (noChangeTrigger !== true) {
                self._triggerChange();
            }
        },
        getPayCalendar: function () {

            var localPayCalendar = JSON.parse(localStorage.getItem('payCalendarID'));
            if (localPayCalendar) {
                return {
                    payCalendarID: parseInt(localPayCalendar, 10)
                };
            }

            var self = this;
            var payCalendarDdl = $('#' + self._id('payCalendars'));
            var payCalendarID = payCalendarDdl ? payCalendarDdl.val() : '0';

            return {
                payCalendarID: parseInt(payCalendarID, 10)
            };
        },
        getPayPeriodOffset: function () {
            var self = this;
            return {
                payPeriodOffset: self.options.payPeriodOffset,
                payPeriodOffsetMode: self.options.payPeriodOffsetMode
            };
        },
        getDateRange: function()
        {
            var self = this;
            var rc =
            {
                from: $('#' + self._id('from')).datepicker("getDate"),
                to: $('#' + self._id('to')).datepicker("getDate")
            };
            return rc;
        },
        getPredefinedRange: function ()
        {
            var self = this;
            var $pdr = $('#' + self._id('predefinedDateRanges'));
            var rc = $pdr.find("input[type=radio]:checked").val();
            return rc;
        },
        calcDateRange: function(range, updateOffset)
        {
            var self = this;
            var rc = { from: null, to: null };
            var today = new Date();
            var payDate;

            switch(range)
            {
                // month to date
                case 'mtd':
                    rc.from = new Date(today.getFullYear(), today.getMonth(), 1);
                    rc.to = today;
                    break;
                // previous month
                case 'prev':
                    rc.from = new Date(today.getFullYear(), today.getMonth()-1, 1);
                    rc.to = new Date(today.getFullYear(), today.getMonth(), 0);
                    break;
                // 1 month
                case '1m':
                    rc.from = new Date(new Date(today).setMonth(today.getMonth()-1));
                    rc.to = today;
                    break;
                // 3 months
                case '3m':
                    rc.from = new Date(new Date(today).setMonth(today.getMonth()-3));
                    rc.to = today;
                    break;
                // quarter to date
                case 'qtd':
                    //calendar quarters: 1-jan, 4-apr, 7-jul, 10-oct
                    //js quarters:       0-jan, 3-apr, 6-jul, 9-oct
                    var month = today.getMonth();  //The getMonth() method returns the month (from 0 to 11) according to local time.
                    rc.from = new Date(today.getFullYear(), month-(month % 3), 1);   // use modulo to adjust to a multiple of 3 (quarter)
                    rc.to = today;
                    break;
                // 6 months
                case '6m':
                    rc.from = new Date(new Date(today).setMonth(today.getMonth()-6));
                    rc.to = today;
                    break;
                // year to date
                case 'ytd':
                    rc.from = new Date(today.getFullYear(), 0, 1);
                    rc.to = today;
                    break;
                // 1 year
                case '1y':
                    rc.from = new Date(new Date(today).setMonth(today.getMonth()-12));
                    rc.to = today;
                    break;
                //current month
                case 'thismo':
                    rc.from = new Date(today.getFullYear(), today.getMonth(), 1);
                    rc.to = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                    break;
                //next month
                case 'nextmo':
                    rc.from = new Date(today.getFullYear(), today.getMonth() + 1, 1);
                    rc.to = new Date(today.getFullYear(), today.getMonth() + 2, 0);
                    break;
                //end of year
                case 'eoy':
                    rc.from = new Date(today.getFullYear(), today.getMonth(), today.getDate());
                    rc.to = new Date(today.getFullYear() + 1, 0, 0);
                    break;
                //last year
                case 'prevyr':
                    rc.from = new Date(today.getFullYear() - 1, 0, 1);
                    rc.to = new Date(today.getFullYear(), 0, 0, 23, 59, 59);
                    break;
                //previous month - 1
                case 'prevM1':
                    rc.from = new Date(today.getFullYear(), today.getMonth() - 2, 1);
                    rc.to = new Date(today.getFullYear(), today.getMonth() - 1, 0, 23, 59, 59);
                    break;
                //previous month - 2
                case 'prevM2':
                    rc.from = new Date(today.getFullYear(), today.getMonth() - 3, 1);
                    rc.to = new Date(today.getFullYear(), today.getMonth() - 2, 0, 23, 59, 59);
                    break;
                case 'pastPayroll':
                    self.setPayDateOffset('decrement', 1);
                    payDate = self.getPayDate(self.options.payPeriodOffset);
                    rc.from = payDate;
                    rc.to = payDate;
                    break;
                case 'thisPayroll':
                    if (updateOffset) {
                        self.setPayDateOffset('set', 0);
                        self._disablePastFutureButtons(false);
                        payDate = self.getPayDate(self.options.payPeriodOffset);
                    }
                    else {
                        payDate = self.getPayDate(0);
                    }
                    rc.from = payDate;
                    rc.to = payDate;
                    break;
                case 'futurePayroll':
                    self.setPayDateOffset('increment', 1);
                    payDate = self.getPayDate(self.options.payPeriodOffset);
                    rc.from = payDate;
                    rc.to = payDate;
                    break;
                default:
                    var selected = null;
                    for (var i = 0; i < self.options.dateRanges.length; i++) {
                        if (self.options.dateRanges[i].value === range) {
                            selected = self.options.dateRanges[i];
                            break;
                        }
                    }

                    if (selected !== null)
                    {
                        if (typeof (selected.dateRange) === "object")
                        {
                            rc = selected.dateRange;
                        }
                        else if (typeof (selected.dateRange) === "function")
                        {
                            rc = selected.dateRange(today);
                        }
                    }
                    break;
            }

            return rc;
        },
        setPayDateOffset: function (action, val) {
            var self = this;
            switch (action) {
                case "set":
                    self.options.payPeriodOffset = val;
                    break;
                case "increment":
                    self.options.payPeriodOffset += val;
                    break;
                case "decrement":
                    self.options.payPeriodOffset -= val;
                    break;
                default:
                    self.options.payPeriodOffset = 0;
                    break;
            }

            this.setPayPeriodOffsetInSession(self.options.payPeriodOffset, "paydate");
            this.setPayPeriodOffsetLocalStorageValue();
        },
        getPayDate: function (offset) {
            var self = this;
            var rc;
            var payCalendar = self.getPayCalendar();
            $.ajax({
                type: 'POST',
                url: ResolveUrl('~/LoanData.asmx') + '/GetPayDateThisOffset?ReadonlySession=true',
                async: false,
                data: JSON.stringify({
                    offset: offset,
                    payCalendarID: payCalendar.payCalendarID
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                success: function (data) {
                    rc = new Date(data);
                }
            });

            return rc;
        },
        setPayCalendarIDInSession: function (payCalendarID) {
            var self = this;

            if (payCalendarID) {
                $.ajax({
                    type: 'POST',
                    url: ResolveUrl('~/LoanData.asmx') + '/SetPayCalendarID',
                    async: false,
                    data: JSON.stringify({
                        PayCalendarID: payCalendarID
                    }),
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    success: function (resp) {
                    }
                });
            }
        },
        setStartStopDateInSession: function () {
            var self = this;
            var o = self.options;

            var dateRange = self.getDateRange();

            if (dateRange.from) {
                $.ajax({
                    type: 'POST',
                    url: ResolveUrl('~/LoanData.asmx') + '/SetStartDate',
                    async: false,
                    data: JSON.stringify({
                        StartDt: dateRange.from,
                    }),
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    success: function (resp) {
                    }
                });
            }

            if (dateRange.to) {
                $.ajax({
                    type: 'POST',
                    url: ResolveUrl('~/LoanData.asmx') + '/SetStopDate',
                    async: false,
                    data: JSON.stringify({
                        StopDt: dateRange.to,
                    }),
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    success: function (resp) {
                    }
                });
            }
        },
        setPayrollStartStopDateInSession: function () {
            var self = this;
            var o = self.options;

            var dateRange = self.getDateRange();

            if (dateRange.from) {
                $.ajax({
                    type: 'POST',
                    url: ResolveUrl('~/LoanData.asmx') + '/SetPayrollStartDate',
                    async: false,
                    data: JSON.stringify({
                        StartDt: dateRange.from,
                    }),
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    success: function (resp) {
                    }
                });
            }

            if (dateRange.to) {
                $.ajax({
                    type: 'POST',
                    url: ResolveUrl('~/LoanData.asmx') + '/SetPayrollStopDate',
                    async: false,
                    data: JSON.stringify({
                        StopDt: dateRange.to,
                    }),
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    success: function (resp) {
                    }
                });
            }
        },
        setPayPeriodOffsetInSession: function (offset, mode) {
            var self = this;

            if (offset) {
                $.ajax({
                    type: 'POST',
                    url: ResolveUrl('~/LoanData.asmx') + '/SetPayPeriodOffset',
                    async: false,
                    data: JSON.stringify({
                        PayPeriodOffset: offset,
                        PayPeriodOffsetMode: mode
                    }),
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    success: function (resp) {
                    }
                });
            }
        },
        // used for debugging purposes only
        getSessionVariables: function () {
            $.ajax({
                type: 'POST',
                url: ResolveUrl('~/LoanData.asmx') + '/GetSessionVariables?ReadonlySession=true',
                async: false,
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                success: function (resp) {
                    console.log("get session variables in dateRange widget");
                    console.log(resp);
                }
            });
        },
        setDateRangeLocalStorageValues: function () {
            var self = this;
            var o = self.options;

            if (window.localStorage) {
                var fromDate = $('#' + self._id('from')).datepicker("getDate");
                var toDate = $('#' + self._id('to')).datepicker("getDate");

                var fromStr = fromDate ? $.datepicker.formatDate('mm/dd/yy', new Date(fromDate)) : null;
                var toStr = toDate ? $.datepicker.formatDate('mm/dd/yy', new Date(toDate)) : null;

                try {

                    if(self.options.payrollDateRange) {
                        localStorage.setItem('PayrollDateRange', JSON.stringify({ from: fromStr, to: toStr }));
                    }
                    else{
                        localStorage.setItem('DateRange', JSON.stringify({ from: fromStr, to: toStr })); 
                    }
                    
                } catch (e) {
                    this.logLocalStorageError(e);
                }
            }
        },
        setPayPeriodOffsetLocalStorageValue: function () {
            var self = this;
            var o = self.options;

            if (window.localStorage) {
                try {
                    localStorage.setItem('PayPeriodOffset', JSON.stringify(o.payPeriodOffset));
                } catch (e) {
                    this.logLocalStorageError(e);
                }
            }
        },
        setPayCalendarLocalStorageValue: function () {
            var self = this;
            var o = self.options;

            if (window.localStorage) {
                try {
                    var payCalendarDdl = $('#' + self._id('payCalendars'));
                    var payCalendarID = payCalendarDdl ? payCalendarDdl.val() : '0';

                    localStorage.setItem('payCalendarID', payCalendarID.toString());
                } catch (e) {
                    this.logLocalStorageError(e);
                }
            }
        },
        logLocalStorageError: function (e) {
            console.log(`Local storage error: ${e}`);
        }
    });
})(jQuery);